import { Injectable } from '@angular/core';

import { RequestService } from '../request';
import { Router } from '@angular/router';
import { TranslateService } from '@ngx-translate/core';
import { HttpClient } from '@angular/common/http';
import { firstValueFrom } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class FileService {
  constructor(
    private request: RequestService,
    private router: Router,
    private translate: TranslateService,
    private http: HttpClient
  ) {}

  public async getFile(filename: string): Promise<void> {
    try {
      const filenameUrlEncoded = encodeURIComponent(filename);
      const apiUrl = this.request.getApiUrl(
        `/api/file/download/${filenameUrlEncoded}`
      );

      const blob = await firstValueFrom(
        this.http.get(apiUrl, {
          responseType: 'blob',
        })
      );

      const blobUrl = URL.createObjectURL(blob);

      // Crear un <a> para forzar la descarga con nombre
      const a = document.createElement('a');
      a.href = blobUrl;
      const cleanedFilename = filename.split(/[/\\]/).pop() || 'file.pdf';

      a.download = cleanedFilename; // ✅ Aquí se mantiene el nombre original
      a.style.display = 'none';
      document.body.appendChild(a);
      a.click();
      document.body.removeChild(a);

      URL.revokeObjectURL(blobUrl); // Limpieza
    } catch (error) {
      console.error('Error fetching file:', error);
      alert(this.translate.instant('ERR_DOWNLOAD'));
    }
  }

  public async uploadFile(
    file: File
  ): Promise<{ message?: string; filename?: string; path?: string }> {
    try {
      const apiUrl = this.request.getApiUrl(`/api/file/upload`);

      const formData = new FormData();
      formData.append('file', file); // el backend espera 'file' como nombre del campo

      return await firstValueFrom(
        this.http.post(apiUrl, formData, {
          observe: 'body',
        })
      );
    } catch (error) {
      console.error('Error uploading file:', error);
      alert(this.translate.instant('ERR_UPLOAD'));
      throw error;
    }
  }
}
